import { render, staticRenderFns } from "./sys0020.vue?vue&type=template&id=6ef56e36&scoped=true"
import script from "./sys0020.vue?vue&type=script&lang=js"
export * from "./sys0020.vue?vue&type=script&lang=js"
import style0 from "./sys0020.vue?vue&type=style&index=0&id=6ef56e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef56e36",
  null
  
)

export default component.exports